import $ from "jquery";
import ComponentRegistry from "../../Common/ComponentRegistry"

import AbstractStore from "../../Common/Stores/AbstractStore";

export default class ProductBrowserStore extends AbstractStore
{
    constructor(url) {
        super(["load", "switchToPage", "itemsPerPage", "sort", "filter"]);

        this.url = url;
        this.items = [];
        this.sorting = "A-Z";
        this.paging = {};
        this.filters = {};

        this.facetStore = ComponentRegistry.getStore("ProductBrowserFacetStore");
    }
    load(state) {
        this.actions.load(state.items, state.paging, state.sorting, state.filters);
    }
    loadItems(items) {
        this.items = items;
        this.trigger();
    }
    loadPaging(paging) {
        this.paging = paging;
        this.trigger();
    }
    loadSorting(sorting) {
        this.sorting = sorting;
        this.trigger();
    }
    loadFilters(filters) {
        this.filters = filters;
        this.trigger();
    }
    switchToPage(page) {
        this.actions.switchToPage(page);
    }
    itemsPerPage(itemsPerPage) {
        this.actions.itemsPerPage(itemsPerPage);
    }
    sort(sorting) {
        this.actions.sort(sorting);
    }
    filter(property, values) {
        this.actions.filter(property, values);
    }
    loadData() {
        if (this.url === null) {
            return;
        }
        this.trigger("loading");
        $.ajax({
            url: this.url,
            method: "GET",
            data: {
                page: this.paging.pages.current,
                perPage: this.paging.items.perPage,
                sorting: this.sorting,
                filters: this.filters,
            },
            dataType: "json",
            success: (result) => {
                this.facetStore.load(result.facets.config);
                this.onLoad(result.items, result.paging, result.sorting, result.facets.values);
            },
        });
    }
    onLoad(items, paging, sorting, filters) {
        this.items = items;
        this.paging = paging;
        this.sorting = sorting;
        this.filters = typeof filters.length === "undefined" ? filters : {};
        this.trigger("idle");
    }
    onItemsPerPage(itemsPerPage) {
        this.paging.items.perPage = itemsPerPage;

        this.onSwitchToPage(1);
    }
    onSwitchToPage(page) {
        this.paging.pages.current = page;
        this.loadData();
    }
    onSort(sorting) {
        this.sorting = sorting;
        this.onSwitchToPage(1);
    }
    onFilter(property, values) {
        if (Array.isArray(this.filters)) {
            this.filters = {};
        }
        if (values === null) {
            delete this.filters[property];
        } else {
            this.filters[property] = values;
        }
        this.onSwitchToPage(1);
    }
    trigger(status) {
        super.trigger(this.items, this.paging, this.sorting, this.filters, status);
    }
}

export function createProductBrowserStore(initialState) {
    const store = new ProductBrowserStore(initialState.url);
    store.onLoad(
        initialState.items,
        initialState.paging,
        initialState.sorting,
        initialState.filters
    );

    return store;
}




// WEBPACK FOOTER //
// ./src-js/Fratello/ProductBrowser/Stores/ProductBrowserStore.jsx